import React from 'react';

const TabWatch = ({className}) => (
  <svg className={className} viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g >
      <path fillRule="evenodd" clipRule="evenodd" d="M14.5001 20.9999C20.2989 20.9999 25.0001 16.2989 25.0001 10.5C25.0001 4.70085 20.2989 2.1e-05 14.5001 2.1e-05C8.70106 2.1e-05 4.00006 4.70085 4.00006 10.5C4.00006 16.2989 8.70106 20.9999 14.5001 20.9999Z" />
      <path d="M18.7044 9.64601C19.3423 10.036 19.3423 10.9625 18.7044 11.3524L12.6967 15.025C12.0303 15.4324 11.1751 14.9528 11.1751 14.1718L11.1751 6.82662C11.1751 6.04562 12.0303 5.56607 12.6967 5.97342L18.7044 9.64601Z" fill="white"/>
    </g>
    <defs>
      <filter id="filter0_d_1858_872" x="0.0616839" y="0" width="28.8766" height="28.8766" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="3.93832"/>
        <feGaussianBlur stdDeviation="1.96916"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1858_872"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1858_872" result="shape"/>
      </filter>
    </defs>
  </svg>

);

export default TabWatch;
